// Language mapping for Monaco Editor - Comprehensive mapping for all Judge0 languages
const JUDGE0_TO_MONACO = {
  // C variants
  48: "c", // C (GCC 7.4.0)
  49: "c", // C (GCC 8.3.0)
  50: "c", // C (GCC 9.2.0)
  75: "c", // C (Clang 7.0.1)
  103: "c", // C (GCC 14.1.0)
  104: "c", // C (Clang 18.1.8)
  110: "c", // C (Clang 19.1.7)

  // C++ variants
  52: "cpp", // C++ (GCC 7.4.0)
  53: "cpp", // C++ (GCC 8.3.0)
  54: "cpp", // C++ (GCC 9.2.0)
  76: "cpp", // C++ (Clang 7.0.1)
  105: "cpp", // C++ (GCC 14.1.0)

  // Java variants
  62: "java", // Java (OpenJDK 13.0.1)
  91: "java", // Java (JDK 17.0.6)
  96: "java", // JavaFX (JDK 17.0.6, OpenJFX 22.0.2)

  // JavaScript variants
  63: "javascript", // JavaScript (Node.js 12.14.0)
  93: "javascript", // JavaScript (Node.js 18.15.0)
  97: "javascript", // JavaScript (Node.js 20.17.0)
  102: "javascript", // JavaScript (Node.js 22.08.0)

  // TypeScript variants
  74: "typescript", // TypeScript (3.7.4)
  94: "typescript", // TypeScript (5.0.3)
  101: "typescript", // TypeScript (5.6.2)

  // Python variants
  70: "python", // Python (2.7.17)
  71: "python", // Python (3.8.1)
  92: "python", // Python (3.11.2)
  100: "python", // Python (3.12.5)
  109: "python", // Python (3.13.2)

  // C# / F#
  51: "csharp", // C# (Mono 6.6.0.161)
  87: "fsharp", // F# (.NET Core SDK 3.1.202)

  // Go
  60: "go", // Go (1.13.5)
  95: "go", // Go (1.18.5)
  106: "go", // Go (1.22.0)
  107: "go", // Go (1.23.5)

  // Rust
  73: "rust", // Rust (1.40.0)
  108: "rust", // Rust (1.85.0)

  // PHP
  68: "php", // PHP (7.4.1)
  98: "php", // PHP (8.3.11)

  // Ruby
  72: "ruby", // Ruby (2.7.0)

  // Swift
  83: "swift", // Swift (5.2.3)

  // Kotlin
  78: "kotlin", // Kotlin (1.3.70)
  111: "kotlin", // Kotlin (2.1.10)

  // Scala
  81: "scala", // Scala (2.13.2)
  112: "scala", // Scala (3.4.2)

  // SQL
  82: "sql", // SQL (SQLite 3.27.2)

  // R
  80: "r", // R (4.0.0)
  99: "r", // R (4.4.1)

  // Lua
  64: "lua", // Lua (5.3.5)

  // Perl
  85: "perl", // Perl (5.28.1)

  // Bash/Shell
  46: "shell", // Bash (5.0.0)

  // Dart
  90: "dart", // Dart (2.19.2)

  // Haskell
  61: "haskell", // Haskell (GHC 8.8.1)

  // OCaml
  65: "ocaml", // OCaml (4.09.0)

  // Clojure
  86: "clojure", // Clojure (1.10.1)

  // Elixir
  57: "elixir", // Elixir (1.9.4)

  // Erlang
  58: "erlang", // Erlang (OTP 22.2)

  // Groovy
  88: "groovy", // Groovy (3.0.3)

  // Objective-C
  79: "objective-c", // Objective-C (Clang 7.0.1)

  // Visual Basic
  84: "vb", // Visual Basic.Net (vbnc 0.0.0.5943)

  // Pascal
  67: "pascal", // Pascal (FPC 3.0.4)

  // Fortran
  59: "fortran", // Fortran (GFortran 9.2.0)

  // COBOL
  77: "cobol", // COBOL (GnuCOBOL 2.2)

  // D
  56: "d", // D (DMD 2.089.1)

  // Common Lisp
  55: "commonlisp", // Common Lisp (SBCL 2.0.0)

  // Prolog
  69: "prolog", // Prolog (GNU Prolog 1.4.5)

  // Octave
  66: "octave", // Octave (5.1.0)

  // Basic
  47: "basic", // Basic (FBC 1.07.1)

  // Assembly
  45: "asm", // Assembly (NASM 2.14.02)

  // Plain Text / Executable / Multi-file (no syntax highlighting)
  43: "plaintext", // Plain Text
  44: "plaintext", // Executable
  89: "plaintext", // Multi-file program
};

/**
 * Get Monaco Editor language ID from Judge0 language ID
 * @param {number} judge0Id - Judge0 language ID
 * @returns {string} Monaco Editor language ID or "plaintext" if not found
 */
export const getMonacoLanguage = (judge0Id) => {
  if (!judge0Id) return "plaintext";
  return JUDGE0_TO_MONACO[judge0Id] || "plaintext";
};

/**
 * Check if a Judge0 language ID is supported
 * @param {number} judge0Id - Judge0 language ID
 * @returns {boolean} True if language is supported
 */
export const isLanguageSupported = (judge0Id) => {
  return judge0Id != null && judge0Id in JUDGE0_TO_MONACO;
};

/**
 * Get all supported Judge0 language IDs
 * @returns {number[]} Array of supported Judge0 language IDs
 */
export const getSupportedLanguageIds = () => {
  return Object.keys(JUDGE0_TO_MONACO).map(Number);
};

export default JUDGE0_TO_MONACO;
